module.exports = __webpack_public_path__ + "img/product_21.39db9b6.jpg";